import { createSlice } from '@reduxjs/toolkit'
import { createActions } from "@helper"
import * as actions from '../action'

const initialState = {
    orderPayInfoList: [], // 付款信息
    invoiceVO: {}, // 发票信息
    refunds: [], // 退货信息
    exchange: [], // 换货信息
    orderMoney: '',
    orderRealMoney: '',
    goods: [],
    discountInfoList: [],
    otherInfo: {} // 其他信息
}

const reducers = createActions({
    setRemark: (state, action) => {
        const { remark = '' } = action.payload
	    const { otherInfo = {} } = state
        return { ...state, otherInfo: { ...otherInfo, remark } }
    },
    getOrderDetailAction: {
        success: (state, action) => {
            const {
	            orderPayInfoList = [],
                invoiceVO = {},
	            refunds = [],
	            packages = [],
	            orderMoney = '',
	            orderRealMoney = '',
	            items = [],
	            itemDisCountInfoList = [],
	            ...other
            } = action.payload || {}
			
            return {
                ...state,
	            otherInfo: other,
	            orderMoney,
	            orderRealMoney,
	            orderPayInfoList,
	            goods: items,
	            discountInfoList: itemDisCountInfoList,
	            packages,
	            invoiceVO,
	            refunds
            }
        }
    }
}, actions)

const orderInfoSlice = createSlice({
    name: 'orderInfo',
    initialState,
    ...reducers
})

export const getOrderMoney = state => state.orderInfo.orderMoney

export const getOrderRealMoney = state => state.orderInfo.orderRealMoney

export const getPayStatus = state => state.orderInfo.otherInfo.payStatus

export const getOrderPayInfoList = state => state.orderInfo.orderPayInfoList

export const getGoods = state => state.orderInfo.goods

export const getDiscountInfoList = state => state.orderInfo.discountInfoList

export const getInvoiceVO = state => state.orderInfo.invoiceVO

export const getRefunds = state => state.orderInfo.refunds

export const getOtherInfo = state => state.orderInfo.otherInfo

export const getPackages = state => state.orderInfo.packages

export const {
    setRemark
} = orderInfoSlice.actions

export default orderInfoSlice
